import { render, staticRenderFns } from "./SolicitudCambioPrograma.vue?vue&type=template&id=45774b50"
import script from "./SolicitudCambioPrograma.vue?vue&type=script&lang=js"
export * from "./SolicitudCambioPrograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports